import React, { Suspense, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import { LinearProgress } from "@mui/material";
import NavBar from "./NavBar";
import TopBar from "./TopBar";
import { Outlet } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: "100vh",
    display: "flex",
    "@media all and (-ms-high-contrast:none)": {
      height: 0, // IE11 fix
    },
  },
  content: {
    paddingTop: 64,
    flexGrow: 1,
    maxWidth: "100%",
    overflowX: "hidden",
    [theme.breakpoints.up("lg")]: {
      paddingLeft: 256,
    },
    [theme.breakpoints.down("xs")]: {
      paddingTop: 48, // 56 to 48
    },
  },
}));

function Statistics({ route }) {
  const classes = useStyles();
  const [openNavBarMobile, setOpenNavBarMobile] = useState(false);
  const [openPatientListMobile, setOpenPatientListMobile] = useState(false);
  const today = () => {
    const date = new Date();
    const day = ("0" + date.getDate()).slice(-2);
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  return (
    <>
      <TopBar
        onOpenNavBarMobile={() => setOpenNavBarMobile(true)}
        onOpenPatientListMobile={() => setOpenPatientListMobile(true)}
      />
      <NavBar
        onMobileClose={() => setOpenNavBarMobile(false)}
        openMobile={openNavBarMobile}
        today={today()}
      />
      <div className={classes.container}>
        <div className={classes.content}>
          <Suspense fallback={<LinearProgress />}>
            <Outlet />
          </Suspense>
        </div>
      </div>
    </>
  );
}

Statistics.propTypes = {
  route: PropTypes.object,
};

export default Statistics;
